import { STATUS_META, type ApplicationStatus, type StatusTone } from '@getslot/domain'
import styles from './status.module.css'
import { cx } from './cx'

/** Тоны с живой точкой: заявка в работе и ждёт события. */
const LIVE_TONES: ReadonlySet<StatusTone> = new Set(['search', 'found', 'client'])

export interface LiveDotProps {
  /** Зелёная точка «нашли дату» на синем фоне вместо оранжевой. */
  tone?: 'cta' | 'live'
  className?: string
}

/** Пульсирующая точка; при reduced motion пульс выключает base.css. */
export function LiveDot({ tone = 'cta', className }: LiveDotProps) {
  return <span aria-hidden="true" className={cx(styles.dot, tone === 'live' && styles.dotLive, className)} />
}

export interface StatusPillProps {
  status: ApplicationStatus
  /** Своя подпись вместо названия статуса (например, для клиента вместо «Нужен оператор»). */
  label?: string
  className?: string
}

/** Цвет статуса всегда дублируется словом. */
export function StatusPill({ status, label, className }: StatusPillProps) {
  const meta = STATUS_META[status]
  return (
    <span className={cx(styles.pill, styles[meta.tone], className)}>
      {LIVE_TONES.has(meta.tone) && <LiveDot />}
      {label ?? meta.label}
    </span>
  )
}
